import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import {
    actions,
    tacticsFetched,
    tacticPlacementsFetch
} from './duck';

import {
    allTacticsEndpoint,
    singleTacticPlacementsEndpoint
} from './selectors';

export function* fetchAllTactics(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(allTacticsEndpoint, action.payload)
            }
        );

        yield put(tacticsFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSingleTacticPlacements(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(singleTacticPlacementsEndpoint, action.payload)
            }
        );

        yield put(tacticPlacementsFetch(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* tacticsSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH_ALL, fetchAllTactics, api),
        takeLatest(actions.FETCH_PLACEMENT, fetchSingleTacticPlacements, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/tactics/saga.js